export interface LivePhoto {
  id: number;
  title: string;
  scene: string;
  time: string;
  img: string;
  viewers: string;
  hot: string;
}

export interface HotEvent {
  id: number;
  tag: string;
  title: string;
  desc: string;
  pics: number;
  reads: string;
  img: string;
  featured?: boolean;
}

export interface Theme {
  id: number;
  name: string;
  en: string;
  count: string;
  desc: string;
  img: string;
}

export interface PhotoItem {
  id: number;
  cat: string;
  title: string;
  place: string;
  img: string;
  likes: number;
  width: string;
}

export interface Collection {
  id: number;
  tag: string;
  title: string;
  cover: string;
  sub: string;
  subImg: string;
  pics: number;
  views: string;
}

export interface HotRank {
  id: number;
  title: string;
  heat: number;
  trend: "up" | "down" | "new";
}

export interface Faq {
  q: string;
  a: string;
}

export const heroImg =
  "https://readdy.ai/api/search-image?query=energetic%20editorial%20event%20photography%20scene%20with%20warm%20stage%20spotlights%20and%20bokeh%20lights%2C%20film%20grain%20texture%2C%20deep%20crimson%20and%20amber%20tonal%20palette%2C%20crowd%20silhouettes%20with%20phone%20flashes%2C%20documentary%20photojournalism%20feel%2C%20atmospheric%20dark%20background%20for%20strong%20text%20contrast&width=1800&height=1100&seq=chigua-hero-01&orientation=landscape";

export const livePhotos: LivePhoto[] = [
  {
    id: 1,
    title: "颁奖礼红毯开场·生图直出",
    scene: "红毯盛典",
    time: "刚刚",
    viewers: "2.3万人在看",
    hot: "LIVE",
    img: "https://readdy.ai/api/search-image?query=candid%20red%20carpet%20event%20photography%20of%20elegant%20figure%20in%20flowing%20gown%2C%20warm%20spotlight%20with%20crowd%20flashes%20behind%2C%20editorial%20magazine%20shot%2C%20film%20grain%2C%20crimson%20tonal%20grade%2C%20authentic%20live%20moment&width=900&height=1200&seq=chigua-live-01&orientation=portrait",
  },
  {
    id: 2,
    title: "品牌发布会·压轴惊喜瞬间",
    scene: "发布会现场",
    time: "3分钟前",
    viewers: "1.8万人在看",
    hot: "LIVE",
    img: "https://readdy.ai/api/search-image?query=press%20conference%20stage%20moment%20with%20splash%20of%20confetti%20and%20warm%20stage%20lights%2C%20fast%20captured%20handheld%20editorial%20photo%2C%20documentary%20photojournalism%2C%20amber%20and%20gold%20tone%2C%20motion%20energy%2C%20authentic%20live%20scene&width=900&height=1200&seq=chigua-live-02&orientation=portrait",
  },
  {
    id: 3,
    title: "新综艺录制·后台花絮生图",
    scene: "综艺录制",
    time: "8分钟前",
    viewers: "9.6千人在看",
    hot: "NEW",
    img: "https://readdy.ai/api/search-image?query=candid%20backstage%20recording%20studio%20photography%20with%20crew%20and%20cast%20preparing%2C%20monitor%20screens%20glowing%2C%20warm%20practical%20lights%2C%20documentary%20film%20grain%2C%20editorial%20insider%20shot%2C%20deep%20red%20and%20cream%20tones&width=900&height=1200&seq=chigua-live-03&orientation=portrait",
  },
  {
    id: 4,
    title: "机场出发厅·穿搭抓拍",
    scene: "机场抓拍",
    time: "15分钟前",
    viewers: "1.2万人在看",
    hot: "LIVE",
    img: "https://readdy.ai/api/search-image?query=airport%20terminal%20style%20snap%20photography%20of%20trendy%20traveler%20with%20luggage%2C%20morning%20light%20through%20glass%20wall%2C%20candid%20street%20snap%20energy%2C%20editorial%20documentary%2C%20soft%20warm%20grade%2C%20real%20candid%20moment&width=900&height=1200&seq=chigua-live-04&orientation=portrait",
  },
  {
    id: 5,
    title: "音乐节收官夜·万人合唱",
    scene: "音乐现场",
    time: "22分钟前",
    viewers: "3.1万人在看",
    hot: "HOT",
    img: "https://readdy.ai/api/search-image?query=music%20festival%20night%20crowd%20with%20raised%20hands%20and%20cellphone%20lights%2C%20big%20warm%20stage%20lighting%20beams%2C%20documentary%20live%20concert%20photo%2C%20film%20grain%2C%20energy%20and%20movement%2C%20crimson%20and%20amber%20palette&width=900&height=1200&seq=chigua-live-05&orientation=portrait",
  },
];

export const hotEvents: HotEvent[] = [
  {
    id: 1,
    tag: "红毯生图",
    title: "星光盛典红毯·百张高清生图全集",
    desc: "从入场到压轴，全程机位直出。礼服细节、表情微光与现场花絮都在这一版图集里，翻一张看一张，不追更的朋友也能一次补齐。",
    pics: 128,
    reads: "38万",
    img: "https://readdy.ai/api/search-image?query=elegant%20red%20carpet%20awards%20ceremony%20wide%20shot%20with%20camera%20flashes%20and%20crowd%20behind%20barricades%2C%20editorial%20photography%2C%20warm%20spotlights%2C%20film%20grain%2C%20documentary%20candid%20style%2C%20gold%20and%20crimson%20tonal%20grade&width=1200&height=900&seq=chigua-event-01&orientation=landscape",
    featured: true,
  },
  {
    id: 2,
    tag: "发布会现场",
    title: "《城市霓虹》开机·台前幕后路透",
    desc: "制片组入场、主创落座到亮灯仪式，现场生图一条龙。我们把后台调度和台前高光的画面都整理成时间线，找图不用来回翻。",
    pics: 86,
    reads: "21万",
    img: "https://readdy.ai/api/search-image?query=film%20production%20launch%20event%20stage%20with%20directors%20seats%20and%20press%20cameras%2C%20ceremonial%20lighting%20moment%2C%20editorial%20documentary%20photography%2C%20warm%20cinematic%20tone%2C%20film%20grain%2C%20authentic%20behind%20the%20scenes&width=1200&height=900&seq=chigua-event-02&orientation=landscape",
  },
  {
    id: 3,
    tag: "综艺录制",
    title: "新综艺首录·现场气氛组侧拍",
    desc: "录制间隙的表情包时刻与全场大合影同框收录。机位多、角度全，蹲守气氛组的名场面都在这里。",
    pics: 64,
    reads: "17万",
    img: "https://readdy.ai/api/search-image?query=television%20variety%20show%20studio%20recording%20wide%20shot%20with%20colorful%20set%20and%20bright%20stage%20lights%2C%20candid%20cast%20laughing%20moment%2C%20documentary%20photography%2C%20warm%20vibrant%20tone%2C%20film%20grain%2C%20lively%20energy&width=1200&height=900&seq=chigua-event-03&orientation=landscape",
  },
  {
    id: 4,
    tag: "机场抓拍",
    title: "周一机场出行·穿搭直击",
    desc: "赶早班机的行程中，把随性穿搭和同款私服一次看够。生图无滤镜直出，还原最真实的机场穿搭现场。",
    pics: 43,
    reads: "9.8万",
    img: "https://readdy.ai/api/search-image?query=casual%20airport%20departure%20lounge%20scene%20with%20fashionable%20traveler%20walking%2C%20soft%20natural%20window%20light%2C%20candid%20editorial%20street%20snap%2C%20warm%20minimalist%20tone%2C%20documentary%20style%2C%20film%20grain&width=1200&height=900&seq=chigua-event-04&orientation=landscape",
  },
];

export const themes: Theme[] = [
  {
    id: 1,
    name: "红毯盛典",
    en: "Red Carpet",
    count: "1,286 张",
    desc: "礼服、珠宝与微表情的高清集合",
    img: "https://readdy.ai/api/search-image?query=red%20carpet%20glamour%20editorial%20shot%20with%20soft%20backlit%20curtain%20and%20sparkle%20bokeh%2C%20elegant%20formal%20attire%20silhouette%2C%20film%20grain%2C%20warm%20crimson%20gold%20tone%2C%20documentary%20photography&width=800&height=1000&seq=chigua-theme-01&orientation=portrait",
  },
  {
    id: 2,
    name: "发布会现场",
    en: "Press Stage",
    count: "968 张",
    desc: "开机仪式与品牌发布的全纪录",
    img: "https://readdy.ai/api/search-image?query=press%20stage%20with%20backdrop%20lighting%20and%20lectern%20under%20warm%20spotlights%2C%20editorial%20conference%20photography%2C%20clean%20modern%20composition%2C%20film%20grain%2C%20crimson%20and%20amber%20grade&width=800&height=1000&seq=chigua-theme-02&orientation=portrait",
  },
  {
    id: 3,
    name: "综艺录制",
    en: "Show Set",
    count: "742 张",
    desc: "棚内现场与后台花絮实录",
    img: "https://readdy.ai/api/search-image?query=colorful%20tv%20studio%20set%20with%20bright%20ring%20light%20and%20stage%20furniture%2C%20documentary%20backstage%20photography%2C%20vibrant%20warm%20tone%2C%20film%20grain%2C%20energetic%20editorial&width=800&height=1000&seq=chigua-theme-03&orientation=portrait",
  },
  {
    id: 4,
    name: "路透街拍",
    en: "Street Snap",
    count: "1,104 张",
    desc: "通勤路上的偶遇式随拍",
    img: "https://readdy.ai/api/search-image?query=candid%20city%20street%20snap%20photography%20of%20stylish%20pedestrian%2C%20blurred%20traffic%20background%2C%20golden%20hour%20light%2C%20documentary%20editorial%20style%2C%20film%20grain%2C%20warm%20minimal%20tone&width=800&height=1000&seq=chigua-theme-04&orientation=portrait",
  },
  {
    id: 5,
    name: "机场抓拍",
    en: "Airport",
    count: "586 张",
    desc: "候机与登机的高清时刻",
    img: "https://readdy.ai/api/search-image?query=modern%20airport%20departure%20hall%20with%20glass%20and%20morning%20sunlight%2C%20traveler%20with%20baggage%20walking%2C%20clean%20editorial%20composition%2C%20soft%20warm%20grade%2C%20documentary%20photography&width=800&height=1000&seq=chigua-theme-05&orientation=portrait",
  },
  {
    id: 6,
    name: "音乐现场",
    en: "Live Stage",
    count: "1,033 张",
    desc: "霓虹灯下的氛围与声浪",
    img: "https://readdy.ai/api/search-image?query=concert%20stage%20with%20warm%20and%20crimson%20beams%20and%20crowd%20silhouettes%2C%20atmospheric%20live%20music%20photography%2C%20film%20grain%2C%20dramatic%20lighting%2C%20documentary%20energy&width=800&height=1000&seq=chigua-theme-06&orientation=portrait",
  },
];

export const photoItems: PhotoItem[] = [
  {
    id: 1,
    cat: "红毯",
    title: "礼服细节高清特写",
    place: "星光盛典",
    img: "https://readdy.ai/api/search-image?query=close%20up%20detail%20of%20sequined%20gown%20fabric%20catching%20warm%20stage%20light%2C%20editorial%20macro%20fashion%20photography%2C%20bokeh%20background%2C%20film%20grain%2C%20crimson%20gold%20tone&width=700&height=880&seq=chigua-photo-01&orientation=portrait",
    likes: 3280,
    width: "tall",
  },
  {
    id: 2,
    cat: "现场",
    title: "压轴登台的挥手瞬间",
    place: "品牌发布会",
    img: "https://readdy.ai/api/search-image?query=figure%20waving%20to%20crowd%20on%20lit%20stage%2C%20warm%20backlight%20and%20lens%20flare%2C%20editorial%20documentary%20photography%2C%20film%20grain%2C%20crimson%20amber%20tone&width=900&height=680&seq=chigua-photo-02&orientation=landscape",
    likes: 2145,
    width: "wide",
  },
  {
    id: 3,
    cat: "街拍",
    title: "咖啡店门口的回眸",
    place: "路透街拍",
    img: "https://readdy.ai/api/search-image?query=candid%20casual%20street%20portrait%20outside%20cafe%2C%20afternoon%20window%20light%2C%20relaxed%20modern%20style%2C%20documentary%20editorial%20snap%2C%20film%20grain%2C%20warm%20neutral%20tone&width=700&height=880&seq=chigua-photo-03&orientation=portrait",
    likes: 1760,
    width: "tall",
  },
  {
    id: 4,
    cat: "机场",
    title: "登机前的大件行李",
    place: "机场抓拍",
    img: "https://readdy.ai/api/search-image?query=traveler%20rolling%20suitcase%20through%20bright%20airport%20corridor%2C%20morning%20glass%20light%2C%20documentary%20editorial%20photography%2C%20soft%20warm%20grade%2C%20film%20grain&width=900&height=680&seq=chigua-photo-04&orientation=landscape",
    likes: 1330,
    width: "wide",
  },
  {
    id: 5,
    cat: "综艺",
    title: "录制间隙的憋笑表情",
    place: "综艺录制",
    img: "https://readdy.ai/api/search-image?query=playful%20backstage%20moment%20in%20bright%20tv%20studio%2C%20cast%20holding%20back%20laughter%2C%20vibrant%20colorful%20set%2C%20documentary%20photography%2C%20film%20grain%2C%20warm%20energetic%20tone&width=700&height=880&seq=chigua-photo-05&orientation=portrait",
    likes: 2890,
    width: "tall",
  },
  {
    id: 6,
    cat: "音乐",
    title: "合唱时的灯海",
    place: "音乐节现场",
    img: "https://readdy.ai/api/search-image?query=sea%20of%20phone%20flashlights%20during%20chorus%20at%20night%20concert%2C%20warm%20stage%20beams%2C%20documentary%20live%20music%20photography%2C%20film%20grain%2C%20dramatic%20crimson%20amber&width=900&height=680&seq=chigua-photo-06&orientation=landscape",
    likes: 4020,
    width: "wide",
  },
  {
    id: 7,
    cat: "红毯",
    title: "入场时的人群欢呼",
    place: "红毯盛典",
    img: "https://readdy.ai/api/search-image?query=arrival%20moment%20with%20cheering%20crowd%20and%20camera%20flashes%20on%20red%20carpet%2C%20editorial%20documentary%20photography%2C%20warm%20spotlight%2C%20film%20grain%2C%20crimson%20tone&width=900&height=680&seq=chigua-photo-07&orientation=landscape",
    likes: 2555,
    width: "wide",
  },
  {
    id: 8,
    cat: "街拍",
    title: "傍晚街角的回望",
    place: "路透街拍",
    img: "https://readdy.ai/api/search-image?query=evening%20street%20corner%20portrait%20with%20warm%20storefront%20lights%2C%20casual%20modern%20outfit%2C%20documentary%20editorial%20snap%2C%20film%20grain%2C%20golden%20amber%20tone&width=700&height=880&seq=chigua-photo-08&orientation=portrait",
    likes: 1920,
    width: "tall",
  },
];

export const collections: Collection[] = [
  {
    id: 1,
    tag: "年度盘点",
    title: "今年红毯最美的高清瞬间",
    cover: "https://readdy.ai/api/search-image?query=glamorous%20red%20carpet%20moment%20with%20elegant%20gown%20and%20sparkling%20light%2C%20editorial%20photography%2C%20film%20grain%2C%20warm%20crimson%20gold%20palette%2C%20documentary%20candid%20style&width=1100&height=1300&seq=chigua-col-01&orientation=portrait",
    sub: "从年初到晚宴季的精选合辑",
    subImg: "https://readdy.ai/api/search-image?query=elegant%20awards%20dinner%20scene%20with%20candle%20lights%20and%20stage%2C%20editorial%20photography%2C%20film%20grain%2C%20warm%20golden%20tone&width=700&height=520&seq=chigua-col-01b&orientation=landscape",
    pics: 320,
    views: "86万",
  },
  {
    id: 2,
    tag: "专题图集",
    title: "综艺名场面表情包图鉴",
    cover: "https://readdy.ai/api/search-image?query=expressive%20candid%20backstage%20tv%20studio%20portrait%20with%20colorful%20set%20lights%2C%20documentary%20photography%2C%20film%20grain%2C%20warm%20vibrant%20energy&width=1100&height=1300&seq=chigua-col-02&orientation=portrait",
    sub: "搞笑、惊讶与感动全收录",
    subImg: "https://readdy.ai/api/search-image?query=lively%20variety%20show%20green%20room%20with%20screens%20and%20crew%2C%20documentary%20photography%2C%20warm%20tone%2C%20film%20grain&width=700&height=520&seq=chigua-col-02b&orientation=landscape",
    pics: 218,
    views: "54万",
  },
  {
    id: 3,
    tag: "穿搭专题",
    title: "机场私服一周穿搭指南",
    cover: "https://readdy.ai/api/search-image?query=stylish%20airport%20travel%20look%20with%20modern%20minimalist%20outfit%2C%20bright%20terminal%20light%2C%20editorial%20fashion%20photography%2C%20soft%20warm%20grade%2C%20film%20grain&width=1100&height=1300&seq=chigua-col-03&orientation=portrait",
    sub: "同款搭配灵感一次看够",
    subImg: "https://readdy.ai/api/search-image?query=flat%20lay%20of%20travel%20fashion%20items%20coat%20bag%20and%20shoes%2C%20editorial%20photography%2C%20warm%20neutral%20tone&width=700&height=520&seq=chigua-col-03b&orientation=landscape",
    pics: 176,
    views: "41万",
  },
  {
    id: 4,
    tag: "现场记录",
    title: "音乐节三日声浪全景",
    cover: "https://readdy.ai/api/search-image?query=three%20day%20music%20festival%20night%20stage%20with%20huge%20crowd%20and%20beams%2C%20documentary%20live%20photo%2C%20film%20grain%2C%20dramatic%20crimson%20amber%20lighting&width=1100&height=1300&seq=chigua-col-04&orientation=portrait",
    sub: "从黄昏到深夜的氛围记录",
    subImg: "https://readdy.ai/api/search-image?query=festival%20crowd%20at%20sunset%20with%20warm%20sky%20and%20banners%2C%20documentary%20photography%2C%20warm%20golden%20tone&width=700&height=520&seq=chigua-col-04b&orientation=landscape",
    pics: 409,
    views: "67万",
  },
];

export const hotRank: HotRank[] = [
  { id: 1, title: "星光盛典红毯·百张高清生图全集", heat: 98, trend: "up" },
  { id: 2, title: "《城市霓虹》开机现场后台花絮", heat: 91, trend: "new" },
  { id: 3, title: "音乐节收官夜·万人合唱灯海", heat: 87, trend: "up" },
  { id: 4, title: "周一机场出行·穿搭直击图集", heat: 82, trend: "down" },
  { id: 5, title: "新综艺首录·气氛组侧拍名场面", heat: 76, trend: "up" },
];

export const faqs: Faq[] = [
  {
    q: "吃瓜图集上的图片是实拍生图吗？",
    a: "是的。图集内的照片均为活动、发布会或录制现场的实拍原图与快速直出生图，原则上不做过度后期。我们会尽量标注拍摄场景与事件名，方便你按图索骥。",
  },
  {
    q: "图集多久更新一次？",
    a: "热点事件发生时通常实时更新，随事件推进持续补充现场照片、路透照与高清生图。你可以在「现场直击」与「热门事件」看到最新收录的时间线。",
  },
  {
    q: "如何更快找到想看的事件照片？",
    a: "可以按「主题图集」分类浏览，也可直接使用顶部搜索输入事件或人物关键词。搜索支持场景名、活动名与标签匹配，帮你一步到位，不用来回翻页。",
  },
  {
    q: "我拍到现场的实拍图，可以投稿吗？",
    a: "当然可以。欢迎通过页面的投稿入口或联系邮箱发来你的现场抓拍，并附上大致时间与场景说明。采纳后会标注来源并在对应事件图集中收录。",
  },
  {
    q: "图片可以转载或用于个人创作吗？",
    a: "站内图片版权归拍摄方与投稿者所有。非商业用途转载请注明出处与图集链接；任何商业使用请先取得授权，可发邮件与我们取得联系。",
  },
];